var map = {
	"./de-AT": 70540,
	"./de-AT.js": 70540,
	"./de-DE": 19404,
	"./de-DE.js": 19404,
	"./en-CA": 83998,
	"./en-CA.js": 83998,
	"./en-GB": 82770,
	"./en-GB.js": 82770,
	"./en-IE": 24709,
	"./en-IE.js": 24709,
	"./en-US": 74805,
	"./en-US.js": 74805,
	"./es-ES": 94092,
	"./es-ES.js": 94092,
	"./i18n": 7258,
	"./i18n.js": 7258,
	"./translate": 18399,
	"./translate.js": 18399
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20827;